(function(){
'use strict';

/* La calibración y las banderas viven en c111-render-config.js */
var _CFGR = window.C111render || {};
var RENDERS = _CFGR.RENDERS || {};
var SHORTCUTS = _CFGR.SHORTCUTS || [];
var BANDERAS = _CFGR.BANDERAS || {};
var ANCHO_DEF = _CFGR.ANCHO_DEFECTO || 9;

var _rt = document.getElementById('c111p');
var REF_KEY = _rt ? _rt.getAttribute('data-ref') : 'aero';

/* ---------------------------------------------------------------------------
   RENDER REAL DEL PRODUCTO
   Regla de Sara y Felipe (14 ago 2026): apenas exista el render del FRENTE de
   la prenda, el cliente diseña sobre su traje de verdad. Verse en el traje que
   va a comprar pesa más que la simetría de las dos caras.

   Si NO hay render propio de espalda, la espalda cae al modelo de referencia.
   Eso sí: cuando eso pasa el aviso de arriba lo dice al cambiar de pestaña, y
   queda anotado en el pedido. El cliente nunca aprueba una espalda creyendo que
   es la suya — eso fue lo que pasó en el pedido #13614.

   Los datos llegan desde metacampos del producto, ver el snippet.
   --------------------------------------------------------------------------- */
function renderReal(){
  if(!_rt) return null;
  var f = _rt.getAttribute('data-real-frente'),
      b = _rt.getAttribute('data-real-espalda'),
      c = _rt.getAttribute('data-real-cal');
  if(!f || !c) return null;
  var cal; try{ cal = JSON.parse(c); }catch(e){ return null; }
  if(!cal || !cal.front || !cal.front.zonas) return null;
  function v(img,o){
    return { img:img, ratio:o.ratio, zoom:o.zoom||1,
             frameCm:o.frameCm, zonas:o.zonas, zip:o.zip||null };
  }
  var out = { front:v(f,cal.front), back:null };
  if(b && cal.back && cal.back.zonas) out.back = v(b,cal.back);
  return out;
}
var REAL = renderReal();
var BASE = RENDERS[REF_KEY] || RENDERS['aero'];
var CFG  = REAL ? { front:REAL.front, back:REAL.back || (BASE?BASE.back:null) } : BASE;
if(!CFG){ return; }
var REAL_FRENTE  = !!REAL;
var REAL_ESPALDA = !!(REAL && REAL.back);

/* ---------------------------------------------------------------------------
   MEDICIÓN AUTOMÁTICA
   Si el producto tiene render propio pero NO trae calibración revisada a mano,
   se mide la imagen aquí mismo, en el navegador, y se sacan la escala y las
   zonas. Así conectar un traje nuevo es solo enlazarle la imagen al producto:
   nadie tiene que calibrar nada ni publicar el tema.
   Si la medición falla, todo se queda con el modelo de referencia.
   --------------------------------------------------------------------------- */
var PEND = null;
if(!REAL && _rt && _rt.getAttribute('data-real-frente') && window.C111medir){
  PEND = window.C111medir.vistaDeUrl(_rt.getAttribute('data-real-frente'),'front')
    .then(function(vf){
      if(!vf) return;
      return window.C111medir.vistaDeUrl(_rt.getAttribute('data-real-espalda'),'back')
        .then(function(vb){
          CFG = { front:vf, back: vb || (BASE?BASE.back:null) };
          REAL_FRENTE  = true;
          REAL_ESPALDA = !!vb;
          HAY_ESPALDA  = !!CFG.back;
          SHORTCUTS = (_CFGR.SHORTCUTS||[]).filter(function(s){ return s.v==='front' || HAY_ESPALDA; });
          textosReales();
        });
    })
    .catch(function(){});
}

/* Si no hay render de espalda — ni propio ni de referencia — no se ofrece
   espalda. Preferimos no personalizarla antes que mostrar otra prenda. */
var HAY_ESPALDA = !!CFG.back;
SHORTCUTS = SHORTCUTS.filter(function(s){ return s.v==='front' || HAY_ESPALDA; });

var LADDER={0:0,1:30000,2:55000,3:80000,4:100000}, MAX=4, TXT_MAX=16, W_MIN=4;
var FLAG_W=5, FLAG_H=3;
var TORNASOL='linear-gradient(115deg,#D470A6 0%,#E0B848 18%,#3FBF9B 40%,#4A8FD4 62%,#9163C8 84%,#D470A6 100%)';
var FUENTES=[
  {k:'anton', l:'Anton — bold deportiva',  css:"'Anton',Impact,sans-serif"},
  {k:'bebas', l:'Bebas Neue — condensada', css:"'Bebas Neue','Arial Narrow',sans-serif"},
  {k:'oswald',l:'Oswald — atlética',       css:"'Oswald','Arial Narrow',sans-serif"},
  {k:'archivo',l:'Archivo Black — sólida', css:"'Archivo Black',Arial Black,sans-serif"}
];
var PAISES=[['COL','Colombia'],['MEX','México'],['PER','Perú'],['ECU','Ecuador'],
  ['CHL','Chile'],['ARG','Argentina'],['BRA','Brasil'],['PAN','Panamá'],
  ['CRI','Costa Rica'],['ESP','España'],['USA','Estados Unidos'],['FRA','Francia'],
  ['ITA','Italia'],['DEU','Alemania'],['PRT','Portugal'],['GBR','Reino Unido']];
var COLORES=[{k:'blanco',l:'Blanco',hex:'#FFFFFF'},{k:'negro',l:'Negro',hex:'#111111'},
  {k:'tornasol',l:'Tornasol',hex:null,grad:TORNASOL}];

var $=function(id){return document.getElementById(id);};
var money=function(n){return '$'+n.toLocaleString('es-CO');};
var dec=function(n){return n.toFixed(1).replace('.',',');};
var colorDe=function(k){for(var i=0;i<COLORES.length;i++)if(COLORES[i].k===k)return COLORES[i];};
var fuenteDe=function(k){for(var i=0;i<FUENTES.length;i++)if(FUENTES[i].k===k)return FUENTES[i];};
var paisDe=function(k){for(var i=0;i<PAISES.length;i++)if(PAISES[i][0]===k)return PAISES[i];};
function banderaSrc(cod){ return BANDERAS[cod] || BANDERAS.COL || ''; }
function banderaChip(cod,px){
  var w=px||20;
  return '<img src="'+banderaSrc(cod)+'" alt="" style="width:'+w+'px;height:'+(w*0.6)+
         'px;vertical-align:-2px;border:1px solid rgba(0,0,0,.18);margin-right:6px">';
}

function estiloColor(k){
  if(k==='tornasol')return 'background-image:'+TORNASOL+';-webkit-background-clip:text;background-clip:text;'+
    'color:transparent;-webkit-text-fill-color:transparent;filter:drop-shadow(0 0 .5px rgba(27,27,27,.55));';
  if(k==='blanco')return 'color:#FFFFFF;-webkit-text-stroke:0.7px rgba(27,27,27,.42);paint-order:stroke fill;';
  return 'color:'+colorDe(k).hex+';';
}
function vistaDe(v){ if(v==='back'&&!HAY_ESPALDA)return CFG.front; return CFG[v]||CFG.front; }
function regionsOf(v){return vistaDe(v).zonas;}
function zonasTodas(){ return HAY_ESPALDA ? CFG.front.zonas.concat(CFG.back.zonas) : CFG.front.zonas; }
function regionDe(k){
  var a=zonasTodas();
  for(var i=0;i<a.length;i++)if(a[i].k===k)return a[i];
  return CFG.front.zonas[0];
}
function vistaDeRegion(k){
  for(var i=0;i<CFG.front.zonas.length;i++)if(CFG.front.zonas[i].k===k)return CFG.front;
  return HAY_ESPALDA ? CFG.back : CFG.front;
}
function maxCm(z){
  var v=vistaDeRegion(z.k);
  return Math.min(z.cap, Math.round((z.x2-z.x1)/100*v.frameCm*0.9*2)/2);
}
function puntoDe(s){
  var zs=vistaDe(s.v).zonas, z=null;
  for(var i=0;i<zs.length;i++)if(zs[i].k===s.r)z=zs[i];
  if(!z)z=zs[0];
  return {x:z.x1+(z.x2-z.x1)*s.rx, y:z.y1+(z.y2-z.y1)*s.ry, reg:z.k};
}

var apliques=[],saved=[],activeId=null,view='front',uid=1,step=1,drag=null,condsTotal=0,condsOk=0;

function blank(si){
  var s=SHORTCUTS[si||0], p=puntoDe(s);
  return {id:uid++,tipo:'texto',texto:'',pais:'COL',view:s.v,x:p.x,y:p.y,reg:p.reg,zip:false,
          ancho:ANCHO_DEF,track:2,fuente:'anton',color:'negro'};
}
function valid(a){return a.tipo==='bandera'?!!a.pais:a.texto.trim().length>0;}
function sW(){return $('c111-inner').clientWidth||500;}
function sH(){return $('c111-inner').clientHeight||500;}
function anchoDe(a){return a.tipo==='bandera'?FLAG_W:a.ancho;}
function fitW(a){var m=maxCm(regionDe(a.reg));if(a.ancho>m)a.ancho=m;if(a.ancho<W_MIN)a.ancho=W_MIN;}

function measure(txt,css,tr,fs){
  var m=$('c111-measure');
  m.style.fontFamily=css;m.style.letterSpacing=tr+'em';m.style.fontSize=fs+'px';
  m.textContent=txt||' ';return m.offsetWidth;
}
function anchoPx(a){ return anchoDe(a)/vistaDe(a.view).frameCm*sW(); }
function fontSizeFor(a){
  var REF_=100, target=anchoPx(a);
  var nat=measure(a.texto,fuenteDe(a.fuente).css,a.track/100,REF_);
  if(!nat)return 18;
  return Math.max(5,Math.min(sH()*0.34,REF_*target/nat));
}
function nearestRegion(a,px,py){
  var l=regionsOf(a.view),best=l[0],bd=Infinity;
  for(var i=0;i<l.length;i++){var cx=(l[i].x1+l[i].x2)/2,cy=(l[i].y1+l[i].y2)/2;
    var d=(px-cx)*(px-cx)+(py-cy)*(py-cy);if(d<bd){bd=d;best=l[i];}}
  return best;
}
function clampFab(a,wP,hP){
  var r=regionDe(a.reg);
  var mnX=r.x1+wP/2,mxX=r.x2-wP/2,mnY=r.y1+hP/2,mxY=r.y2-hP/2;
  a.x=(mnX>mxX)?(r.x1+r.x2)/2:Math.max(mnX,Math.min(mxX,a.x));
  a.y=(mnY>mxY)?(r.y1+r.y2)/2:Math.max(mnY,Math.min(mxY,a.y));
}
function checkZip(a,wP){
  var z=vistaDe(a.view).zip;
  a.zip=!!(z && a.view==='front' && a.y>z.y1 && a.y<z.y2 &&
          (a.x-wP/2)<z.x && (a.x+wP/2)>z.x);
}
function describePos(a){
  var z=regionDe(a.reg), cara=a.view==='front'?'Frente':'Espalda';
  var rx=(a.x-z.x1)/Math.max(1,(z.x2-z.x1)), ry=(a.y-z.y1)/Math.max(1,(z.y2-z.y1));
  var lado;
  if(z.k.indexOf('musloD')===0)      lado='lado derecho';
  else if(z.k.indexOf('musloI')===0) lado='lado izquierdo';
  else {
    var xx = (a.view==='front') ? rx : (1-rx);
    lado = xx<0.38 ? 'lado derecho' : (xx>0.62 ? 'lado izquierdo' : 'centro');
  }
  var alto;
  if(z.k==='torso')        alto = ry<0.45 ? 'pecho' : 'abdomen';
  else if(z.k==='espalda') alto = ry<0.5  ? 'espalda alta' : 'espalda baja';
  else                     alto = 'muslo';
  return cara+' · '+alto+' '+lado;
}
function tallaSel(){
  var f=document.querySelector('form[action*="/cart/add"]');
  if(!f)return '—';
  var s=f.querySelector('[name="id"]');
  if(s&&s.tagName==='SELECT'&&s.selectedOptions[0])return s.selectedOptions[0].textContent.trim();
  var on=f.querySelector('input[type=radio]:checked');
  if(on){var lb=f.querySelector('label[for="'+on.id+'"]');if(lb)return lb.textContent.trim();return on.value;}
  return '—';
}

/* El aviso de arriba cambia según la cara que se esté mirando. Es la pieza que
   evita que alguien apruebe una espalda de referencia creyendo que es la suya. */
function textosVista(){
  var bn=$('c111-banner'); if(!bn) return;
  if(!REAL_FRENTE) return;
  if(view==='back' && !REAL_ESPALDA){
    bn.innerHTML='<b>Esta espalda NO es tu traje.</b> Es el modelo de referencia que usamos '+
      'para que ubiques tu aplique. El frente sí es tu prenda. Tu aplique se estampa sobre el '+
      'traje que compraste, con sus colores.';
  } else {
    bn.innerHTML='<b>Este es tu traje.</b> Estás diseñando sobre el render de la prenda que vas '+
      'a comprar. Los colores en pantalla pueden variar levemente frente a la tela real.';
  }
}
function textosReales(){
  if(!REAL_FRENTE) return;
  var rn=$('c111-refnote');
  if(rn && !rn.__c111){
    rn.__c111=true;
    rn.innerHTML = REAL_ESPALDA
      ? '<b>*</b> Estás viendo <b>tu traje</b>. Lo que apruebas es el <b>diseño del aplique</b> — el texto, el tamaño y la ubicación — y eso es lo que se produce.'
      : '<b>*</b> El <b>frente es tu traje</b>. La espalda todavía se muestra sobre una <b>prenda de referencia</b>: si pones un aplique atrás, se estampa sobre el traje que compraste, con sus colores. Lo que apruebas es el <b>diseño</b> — el texto, el tamaño y la ubicación.';
  }
  var im=$('c111-img'); if(im) im.alt='Tu traje';
  textosVista();
}
textosReales();

function setImg(){ $('c111-img').src = vistaDe(view).img; textosVista(); }
function sizeStage(){
  var st=$('c111-stage'), inner=$('c111-inner'), v=vistaDe(view);
  var w=st.clientWidth;
  var maxH = (window.innerWidth<=940) ? Math.min(window.innerHeight*0.46, w*0.90)
                                      : window.innerHeight*0.62;
  var h=Math.min(w*v.ratio, maxH);
  st.style.height=h+'px';
  inner.style.height='100%';
  inner.style.width=(h/v.ratio)+'px';
  inner.style.transform='scale('+(v.zoom||1)+')';
  inner.style.transformOrigin='center center';
}
function open(){
  if(PEND){ var p=PEND; PEND=null; p.then(abrir); return; }
  abrir();
}
function abrir(){
  apliques = saved.length ? JSON.parse(JSON.stringify(saved)) : [blank(0)];
  activeId=apliques[0].id; view=apliques[0].view;
  $('c111-talla').textContent=tallaSel();
  $('c111p').classList.add('open');
  document.body.style.overflow='hidden';
  goStep(1); setImg(); sizeStage(); render(); ctaCheck();
}
function close(commit){
  if(commit){saved=[];for(var i=0;i<apliques.length;i++)if(valid(apliques[i]))saved.push(JSON.parse(JSON.stringify(apliques[i])));}
  $('c111p').classList.remove('open');
  document.body.style.overflow='';
  paintFicha();
}
function goStep(n){
  step=n;
  $('c111-step1').style.display=n===1?'block':'none';
  $('c111-step2').style.display=n===2?'block':'none';
  $('c111-s1').className=n===1?'on':'';
  $('c111-s2').className=n===2?'on':'';
  $('c111-backbtn').style.display=n===2?'block':'none';
  $('c111-back').textContent=n===2?'← Editar diseño':'← Volver al producto';
  $('c111-main').textContent=n===2?'Confirmar personalización':'Continuar';
  if(n===2)buildStep2();
  render(); $('c111p').scrollTop=0; ctaCheck();
}

function addAp(){ if(apliques.length>=MAX)return;
  var a=blank(apliques.length%SHORTCUTS.length);apliques.push(a);activeId=a.id;setView(a.view,true);render();}
function delAp(id){apliques=apliques.filter(function(a){return a.id!==id;});
  if(!apliques.length)apliques.push(blank(0));
  if(!apliques.filter(function(a){return a.id===activeId;}).length)activeId=apliques[0].id;render();}
function toggleCard(id){activeId=(activeId===id)?null:id;render();}
function find(id){for(var i=0;i<apliques.length;i++)if(apliques[i].id===id)return apliques[i];}
function upd(id,k,v){var a=find(id);if(!a)return;a[k]=v;render();}
function goSc(id,i){var a=find(id);if(!a)return;var s=SHORTCUTS[i],p=puntoDe(s);
  a.view=s.v;a.x=p.x;a.y=p.y;a.reg=p.reg;a.ancho=Math.min(a.ancho,maxCm(regionDe(p.reg)));setView(s.v,true);render();}
function setView(v,quiet){view=v;setImg();sizeStage();
  $('c111-tf').className=v==='front'?'on':'';$('c111-tb').className=v==='back'?'on':'';
  if(!quiet)paintMarks();}

function startDrag(e,id,el){
  e.preventDefault();activeId=id;drag={id:id,el:el};el.classList.add('drag');
  document.addEventListener('pointermove',onMove);
  document.addEventListener('pointerup',onUp);
  document.addEventListener('pointercancel',onUp);
}
function onMove(e){
  if(!drag)return;
  var r=$('c111-inner').getBoundingClientRect(),a=find(drag.id);if(!a)return;
  var rx=((e.clientX-r.left)/r.width)*100, ry=((e.clientY-r.top)/r.height)*100;
  var rg=nearestRegion(a,rx,ry);
  if(rg.k!==a.reg){a.reg=rg.k;var mx=maxCm(rg);if(a.ancho>mx)a.ancho=mx;}
  a.x=rx;a.y=ry;
  var wP=drag.el.offsetWidth/sW()*100, hP=drag.el.offsetHeight/sH()*100;
  clampFab(a,wP,hP);checkZip(a,wP);
  drag.el.style.left=a.x+'%';drag.el.style.top=a.y+'%';
  var rd=$('c111-rd'+a.id);
  if(rd)rd.innerHTML=describePos(a)+' · X <b>'+Math.round(a.x)+'%</b> Y <b>'+Math.round(a.y)+'%</b>';
}
function onUp(){
  if(drag)drag.el.classList.remove('drag');drag=null;
  document.removeEventListener('pointermove',onMove);
  document.removeEventListener('pointerup',onUp);
  document.removeEventListener('pointercancel',onUp);
  render();
}

/* la barra de abajo estorba mientras se diseña: solo aparece al llegar al final */
function ctaCheck(){
  var p=$('c111p'), cta=document.querySelector('.c111-cta');
  if(!p||!cta)return;
  var falta = p.scrollHeight - p.scrollTop - p.clientHeight;
  var scrollea = p.scrollHeight > p.clientHeight + 24;
  var ver = !scrollea || falta < 80;
  cta.style.transition = 'transform .28s ease, opacity .28s ease';
  cta.style.transform   = ver ? 'none' : 'translateY(115%)';
  cta.style.opacity     = ver ? '1' : '0';
  cta.style.pointerEvents = ver ? '' : 'none';
}

function render(){ if(step===1)paintCards(); paintMarks(); paintPrice(); updateMeta(); ctaCheck(); }

function updateMeta(){
  var n=apliques.filter(valid).length, b=$('c111-main');
  if(step===1){ b.disabled=(n===0); }
  else { b.disabled=!(condsTotal>0&&condsOk===condsTotal); }
  var ad=$('c111-addbtn');
  ad.disabled=apliques.length>=MAX;
  ad.textContent=apliques.length>=MAX?'Máximo 4 apliques':'+ Agregar otro aplique';
}

function paintCards(){
  var w=$('c111-cards');w.innerHTML='';
  apliques.forEach(function(a,i){
    fitW(a);
    var rg=regionDe(a.reg), open_=a.id===activeId;
    var label=valid(a)?(a.tipo==='bandera'?banderaChip(a.pais)+'Bandera de '+paisDe(a.pais)[1]:'“'+a.texto+'”'):'<em>Sin configurar</em>';
    var d=document.createElement('div');
    d.className='c111-card'+(open_?' active':'')+(valid(a)?'':' idle');
    var h='<div class="c111-ch" data-t="'+a.id+'"><div class="n">'+(i+1)+'</div>'+
      '<div class="lb">'+label+' <em>· '+describePos(a)+'</em></div>'+
      (apliques.length>1?'<button type="button" class="del" data-d="'+a.id+'">×</button>':'')+
      '<div style="color:#9A9A9A;font-size:12px">▾</div></div><div class="c111-cb">';

    h+='<div class="c111-g"><label>¿Texto o bandera?</label><div class="c111-opts">'+
       '<button type="button" class="c111-o'+(a.tipo==='texto'?' on':'')+'" data-u="'+a.id+'|tipo|texto">Texto</button>'+
       '<button type="button" class="c111-o'+(a.tipo==='bandera'?' on':'')+'" data-u="'+a.id+'|tipo|bandera">Bandera de país</button></div></div>';

    if(a.tipo==='bandera'){
      h+='<div class="c111-g"><label>País</label><select data-sel="'+a.id+'|pais">';
      PAISES.forEach(function(p){h+='<option value="'+p[0]+'"'+(a.pais===p[0]?' selected':'')+'>'+p[1]+'</option>';});
      h+='</select><div class="c111-flagprev"><img src="'+banderaSrc(a.pais)+'" alt=""><span>Así es el parche: <b>rectangular, '+FLAG_W+' × '+FLAG_H+' cm</b></span></div></div>'+
         '<div class="c111-spec"><b>Parche rectangular de '+FLAG_W+' × '+FLAG_H+' cm.</b> Va la bandera sola, sin el código del país. Tamaño, forma y color no se modifican.</div>';
    } else {
      h+='<div class="c111-g"><label>Texto <span class="v">mayúsculas · una línea</span></label>'+
         '<input type="text" value="'+(a.texto||'')+'" placeholder="Ej: VALENTINA" data-tx="'+a.id+'">'+
         '<div class="c111-cnt">'+a.texto.length+'/'+TXT_MAX+' caracteres</div></div>';
      h+='<div class="c111-g"><label>Tipografía</label><select data-sel="'+a.id+'|fuente">';
      FUENTES.forEach(function(f){h+='<option value="'+f.k+'"'+(a.fuente===f.k?' selected':'')+'>'+f.l+'</option>';});
      h+='</select></div>';
      h+='<div class="c111-g"><label>Ancho <span class="v" id="c111-va'+a.id+'">'+dec(a.ancho)+' cm de ancho</span></label>'+
         '<input type="range" min="'+W_MIN+'" max="'+maxCm(rg)+'" step="0.5" value="'+a.ancho+'" data-sl="'+a.id+'|ancho">'+
         '<div class="c111-ends"><span>'+W_MIN+' cm</span><span>'+dec(maxCm(rg))+' cm — máximo</span></div></div>';
      h+='<div class="c111-g"><label>Separación de letras <span class="v" id="c111-vt'+a.id+'">'+(a.track/100).toFixed(2).replace('.',',')+' em</span></label>'+
         '<input type="range" min="0" max="35" step="1" value="'+a.track+'" data-sl="'+a.id+'|track">'+
         '<div class="c111-ends"><span>Juntas</span><span>Separadas</span></div></div>';
      h+='<div class="c111-g"><label>Color <span class="v">'+colorDe(a.color).l+'</span></label><div class="c111-sws">';
      COLORES.forEach(function(c){h+='<button type="button" class="c111-sw'+(a.color===c.k?' on':'')+'" style="background:'+(c.grad||c.hex)+'" title="'+c.l+'" data-u="'+a.id+'|color|'+c.k+'"></button>';});
      h+='</div>';
      if(a.color==='blanco')h+='<p class="c111-hint">En pantalla el blanco se muestra con un <b>borde fino</b> para que puedas verlo sobre la prenda. <b>El aplique real no lleva ese borde.</b></p>';
      if(a.color==='tornasol')h+='<p class="c111-hint">El tornasol <b>cambia de tono según la luz y el ángulo</b>. La pantalla muestra una aproximación.</p>';
      h+='</div>';
    }

    h+='<div class="c111-g"><label>Posición</label><div class="c111-pos" id="c111-rd'+a.id+'">'+
       describePos(a)+' · X <b>'+Math.round(a.x)+'%</b> Y <b>'+Math.round(a.y)+'%</b></div>'+
       '<p class="c111-hint"><b>Arrastra el aplique sobre la prenda</b> para ponerlo donde lo quieras. O usa un punto de partida:</p>'+
       '<p class="c111-hint" style="margin-top:6px">No se personaliza sobre <b>mangas, hombros ni sisas</b>.</p><div class="c111-opts" style="margin-top:8px">';
    SHORTCUTS.forEach(function(s,ix){h+='<button type="button" class="c111-o sm" data-sc="'+a.id+'|'+ix+'">'+s.l+'</button>';});
    h+='</div></div></div>';
    d.innerHTML=h; w.appendChild(d);
  });
  updateMeta();
}

function paintMarks(){
  var st=$('c111-inner');
  Array.prototype.slice.call(st.querySelectorAll('.c111-mark')).forEach(function(e){e.remove();});
  apliques.forEach(function(a){
    if(a.view!==view||!valid(a))return;
    fitW(a);
    var m;
    if(a.tipo==='bandera'){
      var w=anchoPx(a);
      m=document.createElement('img');
      m.src=banderaSrc(a.pais); m.alt='';
      m.className='c111-mark';
      m.style.cssText='left:'+a.x+'%;top:'+a.y+'%;width:'+w+'px;height:'+(w*0.6)+
        'px;border:1px solid rgba(0,0,0,.22);box-sizing:border-box;';
    } else {
      var px=fontSizeFor(a);
      m=document.createElement('div');
      m.className='c111-mark';
      m.style.cssText='left:'+a.x+'%;top:'+a.y+'%;font-family:'+fuenteDe(a.fuente).css+';'+
        'letter-spacing:'+(a.track/100)+'em;font-size:'+px+'px;'+estiloColor(a.color);
      m.textContent=a.texto;
    }
    (function(id,el){el.addEventListener('pointerdown',function(e){startDrag(e,id,el);});})(a.id,m);
    st.appendChild(m);
    var wP=m.offsetWidth/sW()*100;
    clampFab(a,wP,m.offsetHeight/sH()*100); checkZip(a,wP);
    m.style.left=a.x+'%'; m.style.top=a.y+'%';
  });
}

function paintPrice(){
  var n=apliques.filter(valid).length, x=LADDER[n]||0;
  $('c111-ladlbl').textContent=n===0?'Sin personalización':(n===1?'1 personalización':n+' personalizaciones');
  $('c111-ladval').textContent=x?'+'+money(x):'$0';
  $('c111-ladtot').textContent=money(x);
  $('c111-ctatot').textContent=money(x);
}

function buildStep2(){
  var list=apliques.filter(valid);
  $('c111-spell').innerHTML=list.filter(function(a){return a.tipo==='texto';}).map(function(a){
    var f=fuenteDe(a.fuente), dark=a.color==='blanco';
    return '<div class="c111-spell"'+(dark?' style="background:#2A2A2A"':'')+'>'+
      '<div class="lbl"'+(dark?' style="color:#B9B9B9"':'')+'>Revisa que esté bien escrito</div>'+
      '<div class="big" style="font-family:'+f.css+';letter-spacing:'+(a.track/100)+'em;'+
      (dark?'color:#fff;':estiloColor(a.color))+'">'+a.texto+'</div>'+
      '<div class="sub"'+(dark?' style="color:#B9B9B9"':'')+'>Se produce de acuerdo a lo que diseñaste: en '+
      describePos(a).toLowerCase()+', en <b>'+colorDe(a.color).l.toLowerCase()+'</b>. 111 no corrige ortografía.</div></div>';
  }).join('');

  $('c111-revlist').innerHTML=list.map(function(a,i){
    if(a.tipo==='bandera'){var p=paisDe(a.pais);
      return '<li><span>Aplique '+(i+1)+'</span><span>'+banderaChip(p[0],18)+'Bandera de '+p[1]+' · '+describePos(a)+' · '+FLAG_W+' × '+FLAG_H+' cm</span></li>';}
    return '<li><span>Aplique '+(i+1)+'</span><span>“'+a.texto+'” · '+describePos(a)+' · '+
      fuenteDe(a.fuente).l.split(' —')[0]+' · '+dec(a.ancho)+' cm · '+colorDe(a.color).l+'</span></li>';
  }).join('')+'<li><span>Talla</span><span>'+tallaSel()+'</span></li>';

  var conds=[], textos=list.filter(function(a){return a.tipo==='texto';}),
      flags=list.filter(function(a){return a.tipo==='bandera';}),
      zipped=list.filter(function(a){return a.zip;}),
      atras=list.filter(function(a){return a.view==='back';}),
      ubis=[];
  list.forEach(function(a){var d=describePos(a);if(ubis.indexOf(d)<0)ubis.push(d);});

  if(textos.length)conds.push('Revisé la ortografía y confirmo que '+(textos.length===1?'el texto está bien escrito':'los textos están bien escritos')+'. <b>111 imprime tal cual y no corrige.</b>');
  if(flags.length)conds.push('Entiendo que la bandera es un <b>parche rectangular de '+FLAG_W+' × '+FLAG_H+' cm</b>, va sola sin el código del país, y no se puede cambiar de tamaño, color ni forma.');
  conds.push('Yo elegí la ubicación de '+(list.length===1?'mi aplique':'mis apliques')+' (<b>'+ubis.join(' · ')+'</b>) y confirmo que es donde lo quiero. <b>Una vez confirmado no se puede reubicar.</b>');
  if(zipped.length)conds.push('Ubiqué '+(zipped.length===1?'un aplique':zipped.length+' apliques')+' <b>sobre el cierre del frente</b>. Entiendo que se imprimirá <b>partido en dos mitades</b>, con el cierre y unos milímetros de separación en el medio, y que eso es una característica de la prenda, no un defecto.');
  conds.push('Entiendo que <b>no se personaliza sobre mangas, hombros ni sisas</b>, y que si la ubicación que elegí cae sobre una <b>costura o zona no imprimible</b>, 111 la ajustará al punto más cercano posible.');

  if(REAL_FRENTE && atras.length && !REAL_ESPALDA){
    conds.push('Entiendo que el <b>frente que vi es mi traje</b>, pero que la <b>espalda se muestra sobre una prenda de referencia</b>, no sobre la mía. Mi aplique de espalda se estampa sobre el traje que compré, con sus colores. <b>Lo que estoy aprobando es el diseño</b> — texto, tamaño y ubicación.');
  } else if(REAL_FRENTE){
    conds.push('Entiendo que estoy diseñando sobre el <b>render de mi traje</b> y que los colores en pantalla pueden variar levemente frente a la tela real. <b>Lo que estoy aprobando es el diseño</b> — texto, tamaño y ubicación.');
  } else {
    conds.push('Entiendo que la vista previa se muestra sobre una <b>prenda de referencia</b>, no sobre mi traje. Mi aplique se estampa sobre el traje que compré, con sus colores. <b>Lo que estoy aprobando es el diseño</b> — texto, tamaño y ubicación — no la prenda que aparece en pantalla.');
  }

  conds.push('Entiendo que la vista previa es <b>referencial</b>: la posición y el ancho finales pueden variar hasta <b>±1 cm</b> según la talla y el corte.');
  conds.push('Entiendo que este producto es personalizado y por eso <b>no tiene cambio ni devolución</b>, salvo defecto de fabricación.');
  conds.push('Entiendo que 111 me enviará <b>una imagen final para mi visto bueno</b> y que tengo <b>48 horas hábiles</b> para responder. <b>Si no respondo, mi prenda se produce de acuerdo a lo que diseñé aquí</b>, para no retrasar la entrega.');
  conds.push('Entiendo que la personalización agrega <b>3 a 5 días hábiles</b> al tiempo de entrega.');

  condsTotal=conds.length; condsOk=0;
  $('c111-condlist').innerHTML=conds.map(function(c,i){
    return '<label class="c111-cond" id="c111-cond'+i+'"><input type="checkbox" data-c="'+i+'"><span>'+c+'</span></label>';
  }).join('');
  $('c111-tbody').classList.remove('open');
  paintCount();
}
function paintCount(){
  var e=$('c111-condcount');
  e.textContent=condsOk+' de '+condsTotal+' confirmadas';
  e.className='c111-count'+((condsOk===condsTotal&&condsTotal>0)?' ok':'');
}

function paintFicha(){
  var n=saved.length, x=LADDER[n]||0;
  var btn=$('c111-openbtn'), box=$('c111-savedbox'), note=$('c111-fnote');
  if(!btn)return;
  if(!n){
    btn.style.display='flex'; if(note)note.style.display='block';
    if(box)box.style.display='none';
    setProps([]);
    return;
  }
  btn.style.display='none'; if(note)note.style.display='none';
  if(box){
    box.style.display='block';
    box.innerHTML='<div class="hd"><span><span style="color:#1A8245">✓</span> '+
      (n===1?'1 personalización':n+' personalizaciones')+'</span><span>+'+money(x)+'</span></div><ul>'+
      saved.map(function(a){
        if(a.tipo==='bandera'){var p=paisDe(a.pais);
          return '<li><span>'+banderaChip(p[0],18)+'Bandera de '+p[1]+'</span><span>'+describePos(a)+' · '+FLAG_W+' × '+FLAG_H+' cm</span></li>';}
        return '<li><span>“'+a.texto+'”</span><span>'+describePos(a)+' · '+fuenteDe(a.fuente).l.split(' —')[0]+
          ' · '+dec(a.ancho)+' cm · '+colorDe(a.color).l+'</span></li>';
      }).join('')+'</ul>'+
      '<p style="font-size:12px;color:#6E6E6E;line-height:1.55;margin:0 0 14px">Condiciones revisadas y confirmadas una por una. Al agregar al carrito generamos el render y lo adjuntamos a tu pedido.</p>'+
      '<div class="acts"><button type="button" id="c111-edit">Editar</button><button type="button" id="c111-clear">Quitar</button></div>';
    $('c111-edit').addEventListener('click',open);
    $('c111-clear').addEventListener('click',function(){saved=[];paintFicha();});
  }
  setProps(saved);
}

function ioBox(){
  return document.getElementById('infiniteoptions-container') ||
         document.querySelector('.infiniteoptions-container');
}
function ioSelect(){
  var s=document.querySelectorAll('select');
  for(var i=0;i<s.length;i++){
    var n=s[i].getAttribute('name')||'';
    if(n.indexOf('Quiero personalizar')>=0 || n.indexOf('Personalizar mi prenda')>=0) return s[i];
  }
  return null;
}
function ioDetalles(){
  var e=document.querySelectorAll('input[name^="properties"], textarea[name^="properties"]');
  for(var i=0;i<e.length;i++){
    var n=e[i].getAttribute('name')||'';
    if(n.indexOf('Detalles')>=0 && n.indexOf('_io')<0) return e[i];
  }
  return null;
}
function hideLegacy(){
  var b=ioBox(); if(b) b.classList.add('c111-hide-legacy');
}
function setLadder(n){
  var s=ioSelect(); if(!s) return;
  var buscar = n>0 ? new RegExp('^\\s*'+n+'\\s') : /No gracias/i;
  var op=null;
  for(var i=0;i<s.options.length;i++){ if(buscar.test(s.options[i].text)){op=s.options[i];break;} }
  if(!op) return;
  if(s.value!==op.value){
    s.value=op.value;
    s.dispatchEvent(new Event('change',{bubbles:true}));
    s.dispatchEvent(new Event('input',{bubbles:true}));
  }
  var d=ioDetalles();
  if(d){
    var txt = n ? resumenCorto() : '';
    if(d.value!==txt){
      d.value=txt;
      d.dispatchEvent(new Event('change',{bubbles:true}));
      d.dispatchEvent(new Event('input',{bubbles:true}));
    }
  }
}
function resumenCorto(){
  return saved.map(function(a,i){
    if(a.tipo==='bandera') return (i+1)+') Bandera '+paisDe(a.pais)[1]+' 5x3cm · '+describePos(a);
    return (i+1)+') "'+a.texto+'" '+dec(a.ancho)+'cm · '+fuenteDe(a.fuente).l.split(' —')[0]+' · '+colorDe(a.color).l+' · '+describePos(a);
  }).join(' | ');
}

function etiquetaRender(){
  if(REAL_ESPALDA) return 'Traje real del producto (frente y espalda)';
  if(REAL_FRENTE)  return 'Traje real en el frente · ESPALDA sobre modelo de referencia';
  return 'Modelo de referencia';
}

function setProps(list){
  setLadder(list.length);
  var f=document.querySelector('form[action*="/cart/add"]'); if(!f)return;
  Array.prototype.slice.call(f.querySelectorAll('.c111-prop')).forEach(function(e){e.remove();});
  if(!list.length)return;
  function add(k,v){
    var i=document.createElement('input');
    i.type='hidden'; i.className='c111-prop'; i.name='properties['+k+']'; i.value=v;
    f.appendChild(i);
  }
  list.forEach(function(a,ix){
    var p=ix+1;
    if(a.tipo==='bandera'){
      add('Aplique '+p+' · Tipo','Bandera (parche rectangular)');
      add('Aplique '+p+' · País',paisDe(a.pais)[1]);
      add('Aplique '+p+' · Medida',FLAG_W+' x '+FLAG_H+' cm — fija, rectangular, sin código de país');
    } else {
      add('Aplique '+p+' · Tipo','Texto');
      add('Aplique '+p+' · Contenido',a.texto);
      add('Aplique '+p+' · Ancho',dec(a.ancho)+' cm');
      add('Aplique '+p+' · Tipografía',fuenteDe(a.fuente).l.split(' —')[0]);
      add('Aplique '+p+' · Separación',(a.track/100).toFixed(2)+' em');
      add('Aplique '+p+' · Color',colorDe(a.color).l);
      add('Aplique '+p+' · Sobre cierre',a.zip?'SÍ — el cliente lo eligió y lo aceptó: imprimir partido':'No');
    }
    add('Aplique '+p+' · Ubicación',describePos(a));
    add('Aplique '+p+' · Coordenada','X '+Math.round(a.x)+'% · Y '+Math.round(a.y)+'%');
  });
  add('Personalización · Referencia',REF_KEY);
  add('Personalización · Render',etiquetaRender());
  add('Personalización · Ortografía','Confirmada por el cliente');
  add('Personalización · Condiciones',condsTotal+' de '+condsTotal+' aceptadas una por una');
  add('Personalización · Precio','+'+money(LADDER[list.length]||0));
}

function bindATC(f){
  if(window.C111captura) window.C111captura.bind(f);
}
window.C111 = {
  get saved(){ return saved; },
  get CFG(){ return CFG; }, REF_KEY:REF_KEY,
  get REAL(){ return REAL_FRENTE; }, get REAL_ESPALDA(){ return REAL_ESPALDA; },
  vistaDe:vistaDe, banderaSrc:banderaSrc,
  TORNASOL:TORNASOL, FLAG_W:FLAG_W, FLAG_H:FLAG_H,
  fuenteDe:fuenteDe, paisDe:paisDe, colorDe:colorDe, anchoDe:anchoDe, dec:dec, tallaSel:tallaSel
};

function inject(){
  var f=document.querySelector('form[action*="/cart/add"]');
  if(!f||$('c111-openbtn'))return;

  hideLegacy();

  var wrap=document.createElement('div');
  wrap.innerHTML=
    '<p class="c111-lbl">Personalizar mi prenda</p>'+
    '<button type="button" class="c111-open" id="c111-openbtn">'+
      '<span style="display:flex;align-items:center;gap:11px"><span>✦</span><span>Personalizar mi prenda</span></span>'+
      '<span class="ar">→</span></button>'+
    '<p class="c111-fnote" id="c111-fnote">Tu nombre, apodo, número o la bandera de tu país. Ves cómo va a quedar antes de comprar. Desde $30.000.</p>'+
    '<div class="c111-saved" id="c111-savedbox" style="display:none"></div>';

  var btn=f.querySelector('[type="submit"], .t4s-product-form__submit, button[name="add"]');
  if(btn){ var host=btn.closest('.t4s-product-form__buttons, .product-form__buttons') || btn.parentElement;
           host.parentElement.insertBefore(wrap,host); }
  else f.appendChild(wrap);

  $('c111-openbtn').addEventListener('click',open);
  bindATC(f);
  paintFicha();

  /* sin ningún render de espalda: no se ofrece espalda */
  if(!HAY_ESPALDA){
    var tabs=document.querySelector('.c111-tabs');
    if(tabs && !tabs.__c111){
      tabs.__c111=true;
      tabs.style.display='none';
      var n=document.createElement('p');
      n.className='c111-note';
      n.innerHTML='En esta referencia la personalización va <b>en el frente</b>.';
      tabs.parentElement.insertBefore(n,tabs.nextSibling);
    }
  }
}

$('c111-back').addEventListener('click',function(){step===2?goStep(1):close(false);});
$('c111-backbtn').addEventListener('click',function(){goStep(1);});
$('c111-main').addEventListener('click',function(){step===1?goStep(2):close(true);});
$('c111-addbtn').addEventListener('click',addAp);
$('c111-tf').addEventListener('click',function(){setView('front');});
$('c111-tb').addEventListener('click',function(){setView('back');});
$('c111-terms').addEventListener('click',function(){$('c111-tbody').classList.toggle('open'); setTimeout(ctaCheck,10);});

$('c111-cards').addEventListener('click',function(e){
  var t=e.target.closest('[data-t]'), d=e.target.closest('[data-d]'),
      u=e.target.closest('[data-u]'), s=e.target.closest('[data-sc]');
  if(d){e.stopPropagation();delAp(+d.getAttribute('data-d'));return;}
  if(u){var p=u.getAttribute('data-u').split('|');upd(+p[0],p[1],p[2]);return;}
  if(s){var q=s.getAttribute('data-sc').split('|');goSc(+q[0],+q[1]);return;}
  if(t){toggleCard(+t.getAttribute('data-t'));}
});
$('c111-cards').addEventListener('change',function(e){
  var s=e.target.closest('[data-sel]');
  if(s){var p=s.getAttribute('data-sel').split('|');upd(+p[0],p[1],s.value);}
});
$('c111-cards').addEventListener('input',function(e){
  var tx=e.target.closest('[data-tx]'), sl=e.target.closest('[data-sl]');
  if(tx){
    var id=+tx.getAttribute('data-tx'), a=find(id); if(!a)return;
    var v=tx.value.toUpperCase().slice(0,TXT_MAX); tx.value=v; a.texto=v;
    var card=tx.closest('.c111-card');
    card.className='c111-card active'+(valid(a)?'':' idle');
    card.querySelector('.c111-cnt').textContent=v.length+'/'+TXT_MAX+' caracteres';
    card.querySelector('.c111-ch .lb').innerHTML=(valid(a)?'“'+v+'”':'<em>Sin configurar</em>')+' <em>· '+describePos(a)+'</em>';
    updateMeta(); paintMarks(); paintPrice(); return;
  }
  if(sl){
    var q=sl.getAttribute('data-sl').split('|'), b=find(+q[0]); if(!b)return;
    b[q[1]]=parseFloat(sl.value);
    if(q[1]==='ancho') $('c111-va'+b.id).textContent=dec(b.ancho)+' cm de ancho';
    else $('c111-vt'+b.id).textContent=(b.track/100).toFixed(2).replace('.',',')+' em';
    paintMarks();
  }
});
$('c111-condlist').addEventListener('change',function(e){
  var c=e.target.closest('[data-c]'); if(!c)return;
  $('c111-cond'+c.getAttribute('data-c')).classList.toggle('done',c.checked);
  condsOk=$('c111-condlist').querySelectorAll('input:checked').length;
  paintCount(); updateMeta();
});
document.addEventListener('keydown',function(e){
  if(e.key==='Escape'&&$('c111p').classList.contains('open')){step===2?goStep(1):close(false);}
});
$('c111p').addEventListener('scroll',ctaCheck);
window.addEventListener('resize',function(){ if($('c111p').classList.contains('open')){sizeStage();paintMarks();ctaCheck();} });

if(document.readyState!=='loading')inject(); else document.addEventListener('DOMContentLoaded',inject);
setInterval(function(){
  inject(); hideLegacy();
  var f=document.querySelector('form[action*="/cart/add"]'); if(f)bindATC(f);
  if(saved.length) setLadder(saved.length);
},700);

})();
